var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceRestart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4725 10.8938L19.92 10.3275C19.3467 9.73445 18.66 9.26282 17.9006 8.94072C17.1412 8.61862 16.3248 8.45263 15.5 8.45263C14.6752 8.45263 13.8588 8.61862 13.0994 8.94072C12.34 9.26282 11.6533 9.73445 11.08 10.3275C8.64 12.8263 8.64 16.8775 11.08 19.3763C11.6534 19.9691 12.3402 20.4406 13.0995 20.7626C13.8588 21.0846 14.6752 21.2506 15.5 21.2506C16.3248 21.2506 17.1412 21.0846 17.9005 20.7626C18.6598 20.4406 19.3466 19.9691 19.92 19.3763C20.5971 18.6792 21.1087 17.8388 21.4171 16.9173C21.7254 15.9957 21.8225 15.0167 21.7013 14.0525M20.4725 10.8938H17.1575M20.4725 10.8938L20.4713 7.5",
    stroke: "#FF0000",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 4.17251C11.1494 3.07364 13.3056 2.49663 15.5 2.50001C22.4037 2.50001 28 8.09626 28 15C28 21.9038 22.4037 27.5 15.5 27.5C8.59625 27.5 3 21.9038 3 15C3 12.7238 3.60875 10.5875 4.6725 8.75001",
    stroke: "#FF0000",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceRestart);
export default __webpack_public_path__ + "static/media/Device_Restart.fa338f980f554316b25d21f92da499a7.svg";
export { ForwardRef as ReactComponent };